<ng-container *ngTemplateOutlet="getHeader() != null ? pPanel : simple" />

<ng-template #formContent>
  <div [formGroup]="getFormGroup()" [class]="getPanelContentStyleClass()">
    <!-- <ng-template #dynamicComponentContainer></ng-template> -->
    <ng-container *ngFor="let item of config?.config">
      @switch (getFormType(item)) { @case ('input') {
      <eo-input
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (statusChange)="onStatusChange()"
      />
      }@case ('textArea') {
      <eo-textarea
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('checkbox') {
      <eo-checkbox
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('radioButton') {
      <eo-radiobutton
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('dropdown') {
      <eo-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('multiselect') {
      <eo-multiselect
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('countryDropdown') {
      <eo-country-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('specialtyDropdown') {
      <eo-specialty-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('prefectureDropdown') {
      <eo-prefecture-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('cityDropdown') {
      <eo-city-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('userDropdown') {
      <eo-user-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('datepicker') {
      <eo-date-picker
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('fileUpload') {
      <eo-file-upload
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('fileUploadAdvanced') {
      <eo-file-upload-advanced
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('picklist') {
      <eo-picklist
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('richtext') {
      <eo-richtext
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('autocomplete') {
      <eo-autocomplete
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('tableField') {
      <eo-table-field
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('treeDropdown') {
      <eo-tree-dropdown
        #formControlComponent
        [class]="item.styleClass"
        [formControlName]="item.name"
        [config]="item"
        (onRemove)="onRemove(item)"
        (statusChange)="onStatusChange()"
      />
      } @case ('custom') {
      <ng-container
        *ngTemplateOutlet="
          customFormControls[item.name];
          context: {
            formGroup: getFormGroup(),
            config: item,
            styleClass: item.styleClass
          }
        "
      ></ng-container>
      } }
    </ng-container>
  </div>
</ng-template>

<ng-template #pPanel>
  <p-panel [styleClass]="getStyleClass()">
    <ng-template pTemplate="header">
      <div class="w-full flex justify-content-between">
        <div class="flex gap-2 align-items-center">
          <i
            *ngIf="getHeaderIcon()"
            class="text-xl"
            [class]="getHeaderIcon()"
          ></i>
          <div [class]="getHeaderStyleClass()">{{ getHeader() }}</div>
        </div>
        <div class="flex gap-2"></div>
      </div>
    </ng-template>
    <div [class]="getDescriptionStyleClass()">
      {{ getDescription() }}
    </div>
    <ng-container *ngTemplateOutlet="formContent"> </ng-container>
  </p-panel>
</ng-template>

<ng-template #simple>
  <ng-container *ngTemplateOutlet="formContent"> </ng-container>
</ng-template>
